import NoAppointImage from '../../assets/no-data-image.png'; 


export const NoDataContent = ({message = ''}) => {
    return (
        <div className=' flex flex-col items-center text-center'>
            <img
            alt='Empty data'
            width={260}
            src={NoAppointImage}></img>
            
            <div>
                <p>{message ? message : "Please check back later"}</p>
            </div>
            
        </div>
    );
}